import { NgModule } from '@angular/core';
import { AlertComponent, AlertContentDirective, AlertTitleDirective } from './alert';

const ALERT_DIRECTIVES = [AlertComponent, AlertTitleDirective, AlertContentDirective];
@NgModule({
  declarations: [ALERT_DIRECTIVES],
  exports: [ALERT_DIRECTIVES],
})
export class AlertModule {}
